import { fontQuicksand } from "../mixins/mixin";
import styled, {css} from "styled-components";
import { white, deepCoveDark, indigo, babyPurple, lightPurpleTint, lightBlue} from "../../../../app/js/components/loggedout/shared-styles/Colors"
import { CTAPrimaryButton } from "../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton"
import { device, breakpoints } from '../../../../app/js/utils/responsive_utilities';
 
export const Wrapper = styled.div`
    margin:0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background : ${props => props.noBackground === true ? "unset" : deepCoveDark};
    ${fontQuicksand()};
`

export const ContainerWrapper = styled.div`
    /* width: 100%;
    height: 100%; */
`

export const Heading1 = styled.h1`
    color: ${white};
    ${fontQuicksand(2.4, 2.4, 7)}
    text-align: center;
`

export const SubHeading = styled.h4`
    color: ${white};
    text-align: center;
    margin-top: 0;
`

export const FormElement = styled.div`
    text-align: left;
    padding: .8rem 0;
    position: relative;
    label {
        color: ${babyPurple};
        ${fontQuicksand(1.2, 1.6, 7)}
        letter-spacing: .2rem;
    }
    input{
        padding: 1rem 0 0.5rem 0;
        outline: none;
        border: none;
        background: transparent;
        border-bottom: .1rem solid #4F52C3;
        width: 100%;
        color:${white};
    }
    input[type="password"]::placeholder{
      color : ${white};
    }
`

export const InputBox = styled.div`
  position: relative;
  span{
    position: absolute;
    bottom: .3rem;
    right: 1rem;
    color: ${lightPurpleTint};
    ${fontQuicksand(1.1, 1.5, 7)};
    cursor: pointer;
  }
  span.link_style{
    text-decoration: underline;
    color: white;
  }

  input {
    ${fontQuicksand(1.6, 2, 7)};
    ${props => props.text_color && `color : ${props.text_color};`}
  }
`

export const FormHeading = styled(Heading1)`
  ${fontQuicksand(1.6, 2, 7)};
  @media (min-width: ${breakpoints.lg - 1}px) {
    ${fontQuicksand(3.6, 4, 7)};
    ${props => props.isPromoPopup === 'true' ? css`  
      margin: 3rem 0 0;
    ` : null
    };
  }
`
export const FormSubHeading = styled(SubHeading)`
  ${props => props.isPromoPopup === 'true' ? css`
      ${fontQuicksand(1.2, 1.6, 5)};
      padding: 0.4rem 0 3.6rem;
    `: css`  
      ${fontQuicksand(1.1, 2, 5)};
    `
  };
  & > a{
    color: ${babyPurple}
  }
`

export const CTAButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`

export const OfferText = styled.div`
    color: #EDEDF9;
    ${fontQuicksand(1.2, 1.6, 7)}
    padding: 0.8rem;
    text-align: center;
    span{
        padding: 0 1rem;
    }
`

export const CTAOfferButton = styled(CTAPrimaryButton)`
    background : ${white};
    width: 32rem;
    a{
        color : ${props => props.textColor ? props.textColor : indigo};
        font-weight: ${props => props.fontWeight ? props.fontWeight : "bold"};
        font-size: 1.8rem;
        text-align: center;
    }
    &:hover {
        background: ${(props) => props.hoverColor ? props.hoverColor : "inherit"};
    };
    @media (min-width: ${breakpoints.lg}px) {
    width: 37rem;
  }
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; bottom: 0; right: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
  width: 100%;
  height: 100%;
`

export const Modal = styled.div`
  background: ${lightBlue};
  border-radius: 1.2rem;
  width: 32rem;
  min-height: 46rem;
  ${fontQuicksand()};
  box-sizing: border-box;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 1rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  @media (min-width: ${breakpoints.md}px) {
    width: 60%;  
  }

  @media ${device.PhoneTabletLandscape}{
    width: 70%;
    min-height: 26.2rem;
  }


  @media ${device.Desktop}{
    width: 76.9rem;
    padding: 3.2rem 6.4rem;
  }
`

export const PlayButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    background : rgba(26, 26, 26, 0.61);
    position: absolute;
    width: 12.8rem;
    height: 8.96rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    border-radius: 0.8rem;
    cursor: pointer;
    p{
    color: white;
    margin: 0;
    ${fontQuicksand(1.2, 1.4, 7)}
    padding-top: 0.8rem;
    }
`;

export const PlayButton = styled.div`
    width: 0;
    height: 0;
    border-top: 2rem solid transparent;
    border-left: 2.5rem solid ${white};
    border-bottom: 2rem solid transparent;
    color:${white};
    border-radius: .7rem;
`;

export const Circle = styled.div`
    ${props=>css`
        width: ${props.width ? props.width : '0.5rem'};
        height: ${props.height ? props.height : '0.5rem'};
        color: ${props.color ? props.color : white};
        border-radius: 50%;
    `}
`;
export const ModalTitle = styled.p`
  color: ${white};
  ${fontQuicksand(2.4, 3, 7)}
  text-align: center;
  width: 80%;
  margin: 1rem auto;

  @media ${device.Desktop}{
    font-size: 3.6rem;
  }
`

export const ModalBody = styled.div`
  margin-bottom: 4rem;
  @media ${device.Desktop}{
    margin-top: 4rem;
  }
`